export const sessionKey = 'filterParams';
